"use client"

import {RepertoireStatus, repertoireStatusLabel} from "@/types/enums";
import {useState} from "react";
import {patchRepertoire} from "@/lib/api";

type StatusDropdownProps = {
    id: number;
    initialStatus: RepertoireStatus;
};

export default function RepertoireStatusDropdown({id, initialStatus}: StatusDropdownProps) {
    const [status, setStatus] = useState(initialStatus);

    const handleChange = async (value: RepertoireStatus) => {
        if (value === status) return;

        const previous = status;
        setStatus(value);

        try {
            await patchRepertoire(id, { status: value });
        } catch {
            setStatus(previous);
        }
    };

    return (
        <select
            className="w-full rounded-xl border p-3"
            name="status"
            value={status}
            onChange={(e) => handleChange(e.target.value as RepertoireStatus)}
        >
            {Object.values(RepertoireStatus).map(stage => (
                <option key={stage} value={stage}>
                    {repertoireStatusLabel[stage]}
                </option>
            ))}
        </select>
    );
}